import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./CompanyFeatures.css"
import InventoryOutlinedIcon from "@mui/icons-material/InventoryOutlined";
import UploadFileOutlinedIcon from "@mui/icons-material/UploadFileOutlined";
import ImageOutlinedIcon from "@mui/icons-material/ImageOutlined";
import ListAltOutlinedIcon from "@mui/icons-material/ListAltOutlined";
import GroupOutlinedIcon from "@mui/icons-material/GroupOutlined";

import TuneOutlinedIcon from "@mui/icons-material/TuneOutlined";
import FolderOutlinedIcon from "@mui/icons-material/FolderOutlined";
import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";
import SecurityOutlinedIcon from "@mui/icons-material/SecurityOutlined";
import LockPersonOutlinedIcon from "@mui/icons-material/LockPersonOutlined";

import QrCodeScannerOutlinedIcon from "@mui/icons-material/QrCodeScannerOutlined";
import QrCode2OutlinedIcon from "@mui/icons-material/QrCode2Outlined";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import SwapHorizOutlinedIcon from "@mui/icons-material/SwapHorizOutlined";

import NotificationsActiveOutlinedIcon from "@mui/icons-material/NotificationsActiveOutlined";
import WifiOffOutlinedIcon from "@mui/icons-material/WifiOffOutlined";
import SyncOutlinedIcon from "@mui/icons-material/SyncOutlined";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";

import BarChartOutlinedIcon from "@mui/icons-material/BarChartOutlined";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";
import HistoryOutlinedIcon from "@mui/icons-material/HistoryOutlined";
import BookmarkOutlinedIcon from "@mui/icons-material/BookmarkOutlined";

import ApiOutlinedIcon from "@mui/icons-material/ApiOutlined";
import AccountBalanceOutlinedIcon from "@mui/icons-material/AccountBalanceOutlined";
import ChatOutlinedIcon from "@mui/icons-material/ChatOutlined";
import WebhookOutlinedIcon from "@mui/icons-material/WebhookOutlined";

import ArrowForward from "@mui/icons-material/ArrowForward";
import CheckCircle from "@mui/icons-material/CheckCircle";
import AutoAwesome from "@mui/icons-material/AutoAwesome";
import Speed from "@mui/icons-material/Speed";
import Security from "@mui/icons-material/Security";
import Insights from "@mui/icons-material/Insights";
import Devices from "@mui/icons-material/Devices";
import CloudSync from "@mui/icons-material/CloudSync";
import QrCodeScanner from "@mui/icons-material/QrCodeScanner";
import PointOfSale from "@mui/icons-material/PointOfSale";
import NotificationsActive from "@mui/icons-material/NotificationsActive";
import BusinessCenter from "@mui/icons-material/BusinessCenter";
import Inventory2 from "@mui/icons-material/Inventory2";

import Header from "../home-page/home-comps/Header";
import UniverseFooter from "../home-page/home-comps/Footer";
 



const featuresData = [
  {
    section: "Organize",
    description:
      "Organize your inventory and team for smooth business operations.",
    class: "organizeSection",
    items: [
      {
        title: "Items Management",
        desc: "Add, edit, and track all your inventory items with custom details.",
        icon: <InventoryOutlinedIcon style={{ fontSize: "4.4rem" }} />,
        link: "/features/items_management",
      },
      {
        title: "Inventory Import",
        desc: "Upload existing spreadsheets and instantly populate your inventory.",
        icon: <UploadFileOutlinedIcon style={{ fontSize: "4.4rem" }} />,
        link: "/features/inventory_import",
      },
      {
        title: "Item Photos",
        desc: "Attach images to items to track condition and appearance.",
        icon: <ImageOutlinedIcon style={{ fontSize: "4.4rem" }} />,
        link: "/features/item_photos",
      },
      {
        title: "Inventory Lists",
        desc: "View full inventory summary in a clean, organized list.",
        icon: <ListAltOutlinedIcon style={{ fontSize: "4.4rem" }} />,
        link: "/features/inventory_lists",
      },
      {
        title: "Team Access",
        desc: "Invite staff and manage inventory together as a team.",
        icon: <GroupOutlinedIcon style={{ fontSize: "4.4rem" }} />,
        link: "/features/team_access",
      },
    ],
  },

  {
    section: "Customize",
    description: "Customize your system to match your business structure.",
    class: "customizeSection",
    items: [
      {
        title: "Custom Fields",
        desc: "Add unique data fields for your inventory items.",
        icon: <TuneOutlinedIcon style={{ fontSize: "4.4rem" }} />,
        link: "/features/custom_fields",
      },
      {
        title: "Custom Folders",
        desc: "Organize inventory into flexible folder structures.",
        icon: <FolderOutlinedIcon style={{ fontSize: "4.4rem" }} />,
        link: "/features/custom_folders",
      },
      {
        title: "Custom Tags",
        desc: "Tag items across categories for better filtering.",
        icon: <LocalOfferOutlinedIcon style={{ fontSize: "4.4rem" }} />,
        link: "/features/custom_tags",
      },
      {
        title: "User Roles",
        desc: "Control access levels and permissions for staff.",
        icon: <SecurityOutlinedIcon style={{ fontSize: "4.4rem" }} />,
        link: "/features/user_roles",
      },
      {
        title: "Custom Permissions",
        desc: "Define what each user can view, edit, or delete.",
        icon: <LockPersonOutlinedIcon style={{ fontSize: "4.4rem" }} />,
        link: "/features/permissions",
      },
    ],
  },

  {
    section: "Manage",
    description: "Manage stock flow, sales, and inventory operations.",
    class: "manageSection",
    items: [
      {
        title: "Barcode Scanning",
        desc: "Scan products using mobile camera or barcode scanner.",
        icon: <QrCodeScannerOutlinedIcon style={{ fontSize: "4.4rem" }} />,
        link: "/features/barcode_scanning",
      },
      {
        title: "QR Code Tracking",
        desc: "Generate and scan QR codes for faster tracking.",
        icon: <QrCode2OutlinedIcon style={{ fontSize: "4.4rem" }} />,
        link: "/features/qr_tracking",
      },
      {
        title: "Purchase Orders",
        desc: "Create and manage supplier purchase orders easily.",
        icon: <ReceiptLongOutlinedIcon style={{ fontSize: "4.4rem" }} />,
        link: "/features/purchase_orders",
      },
      {
        title: "Check In / Check Out",
        desc: "Track item usage and returns within your business.",
        icon: <SwapHorizOutlinedIcon style={{ fontSize: "4.4rem" }} />,
        link: "/features/check_in_out",
      },
    ],
  },

  {
    section: "Track & Update",
    description: "Stay updated with real-time inventory tracking.",
    class: "trackSection",
    items: [
      {
        title: "Low Stock Alerts",
        desc: "Get notified when stock levels are running low.",
        icon: (
          <NotificationsActiveOutlinedIcon style={{ fontSize: "4.4rem" }} />
        ),
        link: "/features/low_stock_alerts",
      },
      {
        title: "Offline Mode",
        desc: "Continue working even without internet connection.",
        icon: <WifiOffOutlinedIcon style={{ fontSize: "4.4rem" }} />,
        link: "/features/offline_mode",
      },
      {
        title: "Auto Sync",
        desc: "Automatically sync inventory across all devices.",
        icon: <SyncOutlinedIcon style={{ fontSize: "4.4rem" }} />,
        link: "/features/auto_sync",
      },
      {
        title: "Email Alerts",
        desc: "Receive stock and sales notifications via email.",
        icon: <EmailOutlinedIcon style={{ fontSize: "4.4rem" }} />,
        link: "/features/email_alerts",
      },
    ],
  },

  {
    section: "Reports",
    description: "Analyze your business performance with powerful reports.",
    class: "reportSection",
    items: [
      {
        title: "Sales Reports",
        desc: "Track daily, weekly, and monthly sales performance.",
        icon: <BarChartOutlinedIcon style={{ fontSize: "4.4rem" }} />,
        link: "/features/sales_reports",
      },
      {
        title: "Inventory Reports",
        desc: "View full stock summary and item movement history.",
        icon: <AssessmentOutlinedIcon style={{ fontSize: "4.4rem" }} />,
        link: "/features/inventory_reports",
      },
      {
        title: "Activity Logs",
        desc: "Monitor all staff actions in the system.",
        icon: <HistoryOutlinedIcon style={{ fontSize: "4.4rem" }} />,
        link: "/features/activity_logs",
      },
      {
        title: "Saved Reports",
        desc: "Save and reuse custom report filters anytime.",
        icon: <BookmarkOutlinedIcon style={{ fontSize: "4.4rem" }} />,
        link: "/features/saved_reports",
      },
    ],
  },

  {
    section: "Integrations",
    description: "Connect your system with external tools and services.",
    class: "integrationSection",
    items: [
      {
        title: "API Access",
        desc: "Connect your app with our API for automation.",
        icon: <ApiOutlinedIcon style={{ fontSize: "4.4rem" }} />,
        link: "/features/api",
      },
      {
        title: "QuickBooks Integration",
        desc: "Sync invoices and financial data with QuickBooks.",
        icon: <AccountBalanceOutlinedIcon style={{ fontSize: "4.4rem" }} />,
        link: "/features/quickbooks",
      },
      {
        title: "Slack Notifications",
        desc: "Receive inventory updates directly in Slack.",
        icon: <ChatOutlinedIcon style={{ fontSize: "4.4rem" }} />,
        link: "/features/slack",
      },
      {
        title: "Webhooks",
        desc: "Automate workflows using event-based triggers.",
        icon: <WebhookOutlinedIcon style={{ fontSize: "4.4rem" }} />,
        link: "/features/webhooks",
      },
    ],
  },
];
 
export default function CompanyFeatures() {
  const redirect = useNavigate();

  const [activeGroup, setActiveGroup] = useState("All");

  const groups = useMemo(() => {
    return ["All", ...featuresData.map((group) => group.section)];
  }, []);

  const visibleGroups =
    activeGroup === "All"
      ? featuresData
      : featuresData.filter((group) => group.section === activeGroup);

  const totalFeatures = featuresData.reduce(
    (total, group) => total + group.items.length,
    0
  );

  return (
    <section className="companyFeaturesPage fx-cl fx-ac"> 
      {/* ================================================================
          HERO
      ================================================================ */}

      <section className="featuresHero">
        <div className="featuresHeroGlow featuresHeroGlowOne" />
        <div className="featuresHeroGlow featuresHeroGlowTwo" />

        <div className="featuresHeroInner">
          <div className="featuresHeroBadge fx-ac fx-jc space">
            <AutoAwesome />
            <span>THE UNIVERSE INVENTORY ECOSYSTEM</span>
          </div>

          <div className="featuresHeroContent fx-cl fx-ac">
            <h1 className="featuresHeroTitle">
              Everything you need to
              <span> run inventory smarter.</span>
            </h1>

            <p className="featuresHeroDescription">
              Powerful inventory, sales, purchasing, reporting, scanning,
              notifications and business management tools — designed to work
              together as one intelligent ecosystem.
            </p>

            <div className="featuresHeroActions fx-ac fx-jc space2">
              <button
                className="featuresPrimaryButton fx-ac fx-jc space"
                onClick={() => redirect("/register")}
              >
                <span>Start Using Universe</span>
                <ArrowForward />
              </button>

              <button
                className="featuresSecondaryButton fx-ac fx-jc space"
                onClick={() => redirect("/solutions/all-solutions")}
              >
                <span>Explore Solutions</span>
              </button>
            </div>
          </div>

          <div className="featuresHeroStats">
            <div className="featuresHeroStat">
              <span className="featuresHeroStatNumber">{totalFeatures}+</span>
              <span className="featuresHeroStatLabel">
                Business capabilities
              </span>
            </div>

            <div className="featuresHeroStat">
              <span className="featuresHeroStatNumber">
                {featuresData.length}
              </span>
              <span className="featuresHeroStatLabel">
                Feature ecosystems
              </span>
            </div>

            <div className="featuresHeroStat">
              <span className="featuresHeroStatNumber">24/7</span>
              <span className="featuresHeroStatLabel">
                Connected operations
              </span>
            </div>

            <div className="featuresHeroStat">
              <span className="featuresHeroStatNumber">1</span>
              <span className="featuresHeroStatLabel">
                Unified platform
              </span>
            </div>
          </div>
        </div>
      </section>

      {/* ================================================================
          INTRO
      ================================================================ */}

      <section className="featuresIntro sectionBlock pdlargeX">
        <div className="featuresIntroGrid">
          <div className="featuresIntroHeading fx-cl spacem">
            <span className="featuresEyebrow">BUILT FOR REAL BUSINESS</span>

            <h2 className="fs7 fw600">
              More than features.
              <span> A complete operating system for your inventory.</span>
            </h2>
          </div>

          <div className="featuresIntroText fx-cl space2">
            <p className="fs4">
              Universe Inventory brings the critical parts of your business
              into one connected environment, helping you know what you have,
              where it is, what is moving, what is selling and what requires
              your attention.
            </p>

            <p className="fs4">
              From receiving stock to selling products, scanning barcodes,
              monitoring transactions and understanding business performance,
              every capability is designed to work together.
            </p>
          </div>
        </div>
      </section>

      {/* ================================================================
          ECOSYSTEM
      ================================================================ */}

      <section className="featuresEcosystem sectionBlock pdlargeX">
        <div className="featuresSectionHeading fx-cl fx-ac space2">
          <span className="featuresEyebrow">ONE CONNECTED ECOSYSTEM</span>

          <h2 className="fs7 fw600">
            Your inventory does not operate alone.
          </h2>

          <p className="fs4">
            Universe Inventory connects the tools your team uses every day.
          </p>
        </div>

        <div className="featuresEcosystemGrid">
          <div className="ecosystemCard ecosystemCardLarge">
            <div className="ecosystemCardGlow" />

            <div className="ecosystemIcon fx-ac fx-jc">
              <Inventory2 />
            </div>

            <div className="fx-cl space1">
              <span className="featuresCardLabel">CORE PLATFORM</span>

              <h3 className="fs6 fw600">Universe Inventory</h3>

              <p className="fs4">
                Your central command centre for products, inventory,
                purchasing, sales, transfers, returns, adjustments, reporting
                and business operations.
              </p>
            </div>

            <button
              className="featuresTextButton fx-ac space"
              onClick={() => redirect("/solutions/all-solutions")}
            >
              <span>Explore platform</span>
              <ArrowForward />
            </button>
          </div>

          <div className="ecosystemCard">
            <div className="ecosystemIcon fx-ac fx-jc">
              <CloudSync />
            </div>

            <div className="fx-cl space1">
              <span className="featuresCardLabel">CONNECTED MOBILE APP</span>

              <h3 className="fs6 fw600">Uni-Cloud</h3>

              <p className="fs4">
                Stay connected to business activity with realtime transaction
                notifications designed to keep you informed wherever you are.
              </p>
            </div>

            <div className="ecosystemMiniFeature fx-ac space">
              <NotificationsActive />
              <span>Realtime notifications</span>
            </div>
          </div>

          <div className="ecosystemCard">
            <div className="ecosystemIcon fx-ac fx-jc">
              <QrCodeScanner />
            </div>

            <div className="fx-cl space1">
              <span className="featuresCardLabel">SMART SCANNING</span>

              <h3 className="fs6 fw600">Cam-Scanner</h3>

              <p className="fs4">
                Turn your computer camera into a practical barcode scanning
                tool for faster product identification and inventory workflows.
              </p>
            </div>

            <div className="ecosystemMiniFeature fx-ac space">
              <QrCodeScanner />
              <span>Fast barcode scanning</span>
            </div>
          </div>

          <div className="ecosystemCard">
            <div className="ecosystemIcon fx-ac fx-jc">
              <PointOfSale />
            </div>

            <div className="fx-cl space1">
              <span className="featuresCardLabel">SELLING EXPERIENCE</span>

              <h3 className="fs6 fw600">Universe Point of Sale</h3>

              <p className="fs4">
                A connected point-of-sale experience built to help businesses
                process sales while keeping inventory and transaction activity
                synchronized.
              </p>
            </div>

            <div className="ecosystemMiniFeature fx-ac space">
              <Speed />
              <span>Fast checkout workflows</span>
            </div>
          </div>
        </div>
      </section>

      {/* ================================================================
          FEATURE NAVIGATION
      ================================================================ */}

      <section className="featuresExplorer sectionBlock pdlargeX">
        <div className="featuresSectionHeading fx-cl fx-ac space2">
          <span className="featuresEyebrow">FEATURE LIBRARY</span>

          <h2 className="fs7 fw600">Explore every capability.</h2>

          <p className="fs4">
            Discover the tools that make Universe Inventory powerful.
          </p>
        </div>

        <div className="featuresCategoryBar">
          {groups.map((group) => (
            <button
              key={group}
              type="button"
              className={
                activeGroup === group
                  ? "featuresCategoryButton featuresCategoryButtonActive"
                  : "featuresCategoryButton"
              }
              onClick={() => setActiveGroup(group)}
            >
              {group}
            </button>
          ))}
        </div>

        <div className="featuresGroups">
          {visibleGroups.map((group, index) => (
            <div
              key={group.section}
              className={`featureGroupBlock ${
                group.class || ""
              }`}
            >
              <div className="featureGroupHeader fx-ac fx-jb">
                <div className="fx-cl spacem">
                  <span className="featureGroupNumber">
                    {String(index + 1).padStart(2, "0")}
                  </span>

                  <h3 className="fs6 fw600">{group.section}</h3>

                  {group.description && (
                    <p className="fs4">{group.description}</p>
                  )}
                </div>

                <div className="featureGroupLine" />
              </div>

              <div className="featuresAdvancedGrid">
                {group.items.map((item, i) => (
                  <article
                    key={i}
                    className="advancedFeatureCard"
                    onClick={() => redirect(item.link)}
                  >
                    <div className="advancedFeatureCardTop fx-ac fx-jb">
                      <div className="advancedFeatureIcon fx-ac fx-jc">
                        {item.icon}
                      </div>

                      <span className="advancedFeatureIndex">
                        {String(i + 1).padStart(2, "0")}
                      </span>
                    </div>

                    <div className="advancedFeatureBody fx-cl space1">
                      <h4 className="fs5 fw600">{item.title}</h4>

                      <p className="fs4">{item.desc}</p>
                    </div>

                    <div className="advancedFeatureFooter fx-ac fx-jb">
                      <span>Explore feature</span>
                      <ArrowForward />
                    </div>
                  </article>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* ================================================================
          WHY IT MATTERS
      ================================================================ */}

      <section className="featuresAdvantages sectionBlock pdlargeX">
        <div className="featuresSectionHeading fx-cl fx-ac space2">
          <span className="featuresEyebrow">DESIGNED AROUND YOUR BUSINESS</span>

          <h2 className="fs7 fw600">
            Powerful underneath.
            <span> Simple on the surface.</span>
          </h2>
        </div>

        <div className="featuresAdvantagesGrid">
          <div className="featureAdvantageCard">
            <div className="featureAdvantageIcon fx-ac fx-jc">
              <Speed />
            </div>

            <h3 className="fs5 fw600">Move faster</h3>

            <p className="fs4">
              Reduce repetitive work and give your team faster ways to
              complete everyday inventory operations.
            </p>
          </div>

          <div className="featureAdvantageCard">
            <div className="featureAdvantageIcon fx-ac fx-jc">
              <Insights />
            </div>

            <h3 className="fs5 fw600">Understand your business</h3>

            <p className="fs4">
              Turn operational activity into useful information that helps you
              understand sales, stock and business performance.
            </p>
          </div>

          <div className="featureAdvantageCard">
            <div className="featureAdvantageIcon fx-ac fx-jc">
              <Security />
            </div>

            <h3 className="fs5 fw600">Stay in control</h3>

            <p className="fs4">
              Keep important business operations organized while giving the
              right people access to the right capabilities.
            </p>
          </div>

          <div className="featureAdvantageCard">
            <div className="featureAdvantageIcon fx-ac fx-jc">
              <Devices />
            </div>

            <h3 className="fs5 fw600">Work across your ecosystem</h3>

            <p className="fs4">
              Connect your inventory operation with the tools and experiences
              your team needs throughout the day.
            </p>
          </div>
        </div>
      </section>

      {/* ================================================================
          WORKFLOW
      ================================================================ */}

      <section className="featuresWorkflow sectionBlock pdlargeX">
        <div className="featuresWorkflowShell">
          <div className="featuresWorkflowContent fx-cl space2">
            <span className="featuresEyebrow">FROM STOCK TO SALE</span>

            <h2 className="fs7 fw600">
              One workflow.
              <span> Multiple connected experiences.</span>
            </h2>

            <p className="fs4">
              Universe Inventory is designed around the way real businesses
              operate — where receiving, storing, selling, transferring,
              adjusting and reporting are all part of the same story.
            </p>

            <button
              className="featuresPrimaryButton fx-ac fx-jc space"
              onClick={() => redirect("/solutions/all-solutions")}
            >
              <span>See How It Works</span>
              <ArrowForward />
            </button>
          </div>

          <div className="featuresWorkflowSteps">
            <div className="workflowStep">
              <span className="workflowStepNumber">01</span>

              <div className="workflowStepIcon fx-ac fx-jc">
                <BusinessCenter />
              </div>

              <div className="fx-cl spacem">
                <h3 className="fs5 fw600">Receive</h3>
                <p className="fs3">
                  Bring new inventory into your operation.
                </p>
              </div>
            </div>

            <div className="workflowConnector" />

            <div className="workflowStep">
              <span className="workflowStepNumber">02</span>

              <div className="workflowStepIcon fx-ac fx-jc">
                <Inventory2 />
              </div>

              <div className="fx-cl spacem">
                <h3 className="fs5 fw600">Manage</h3>
                <p className="fs3">
                  Organize and monitor stock across your business.
                </p>
              </div>
            </div>

            <div className="workflowConnector" />

            <div className="workflowStep">
              <span className="workflowStepNumber">03</span>

              <div className="workflowStepIcon fx-ac fx-jc">
                <PointOfSale />
              </div>

              <div className="fx-cl spacem">
                <h3 className="fs5 fw600">Sell</h3>
                <p className="fs3">
                  Process transactions through connected sales tools.
                </p>
              </div>
            </div>

            <div className="workflowConnector" />

            <div className="workflowStep">
              <span className="workflowStepNumber">04</span>

              <div className="workflowStepIcon fx-ac fx-jc">
                <Insights />
              </div>

              <div className="fx-cl spacem">
                <h3 className="fs5 fw600">Understand</h3>
                <p className="fs3">
                  Turn activity into meaningful business insight.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ================================================================
          FEATURE PROMISE
      ================================================================ */}

      <section className="featuresPromise sectionBlock pdlargeX">
        <div className="featuresPromiseGrid">
          <div className="featuresPromiseVisual">
            <div className="promiseOrbit promiseOrbitOne" />
            <div className="promiseOrbit promiseOrbitTwo" />

            <div className="promiseCore fx-cl fx-ac fx-jc">
              <AutoAwesome />
              <span>UNIVERSE</span>
              <strong>INVENTORY</strong>
            </div>
          </div>

          <div className="featuresPromiseContent fx-cl space2">
            <span className="featuresEyebrow">THE UNIVERSE APPROACH</span>

            <h2 className="fs7 fw600">
              Every feature has a purpose.
            </h2>

            <p className="fs4">
              We do not build features simply to make a longer feature list.
              We build tools to solve the operational problems businesses face
              every day.
            </p>

            <div className="featuresPromiseList fx-cl space">
              <div className="fx-ac space">
                <CheckCircle />
                <span className="fs3">Built around practical workflows</span>
              </div>

              <div className="fx-ac space">
                <CheckCircle />
                <span className="fs3">Connected across the ecosystem</span>
              </div>

              <div className="fx-ac space">
                <CheckCircle />
                <span className="fs3">Designed for growing businesses</span>
              </div>

              <div className="fx-ac space">
                <CheckCircle />
                <span className="fs3">Focused on clarity and control</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ================================================================
          CTA
      ================================================================ */}

      <section className="featuresCTA sectionBlock pdlargeX">
        <div className="featuresCTAShell fx-cl fx-ac">
          <div className="featuresCTAGlow" />

          <span className="featuresEyebrow">READY TO EXPLORE?</span>

          <h2 className="fs8 fw600">
            Your business deserves
            <span> an Advanced inventory experience.</span>
          </h2>

          <p className="fs4">
            Explore Universe Inventory and discover a more connected way to
            manage your business.
          </p>

          <div className="featuresCTAButtons fx-ac fx-jc space2">
            <button
              className="featuresPrimaryButton fx-ac fx-jc space"
              onClick={() => redirect("/register")}
            >
              <span>Create Your Account</span>
              <ArrowForward />
            </button>

            <button
              className="featuresSecondaryButton fx-ac fx-jc space"
              onClick={() => redirect("/contact-us")}
            >
              <span>Talk to Us</span>
            </button>
          </div>
        </div>
      </section>

      <UniverseFooter />
    </section>
  );
} 